

import Vue from 'vue'
import App from './App'
import router from './router'
import './styles/ftui.less'
import './styles/style.less'
import store from './store'
import { drag, vaildate } from '@/utils'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'


import echarts from 'echarts'
import MtaH5 from 'mta-h5-analysis'
import VConsole from 'vconsole'
import config from '@/config'
import cookies from 'js-cookie'

/* eslint-disable */
if (config.debug) {
var vConsole = new VConsole()
}

Vue.use(DatetimePlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.config.productionTip = false

Vue.directive('drag', drag)
/* eslint-disable */
Vue.prototype.$vaildate = vaildate
Vue.prototype.$echarts = echarts

MtaH5.init({
'sid': '500575540', //必填，统计用的appid
'cid': '500575544', //如果开启自定义事件，此项目为必填，否则不填
'autoReport': 0,//是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
'senseHash': 1, //hash锚点是否进入url统计
'senseQuery': 1, //url参数是否进入url统计
'performanceMonitor': 1,//是否开启性能监控
'ignoreParams':[] //开启url参数上报时，可忽略部分参数拼接上报
})


setTimeout(function () {
cookies.set('error_redirect', 0)
}, 1000 * 60)

/* eslint-disable no-new */

new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js